module.exports = __webpack_public_path__ + "static/media/merriamMoreIcon.50493171.png";